import classNames from 'classnames'

import * as styles from './AccordionAnimatedContent.module.css'

function AccordionAnimatedContent({
  children,
  className = styles.AccordionAnimatedContent,
  contentWrapperClassName = styles.AccordionAnimatedContentWrapper,
  isOpen,
  ref,
  ...restProps
}) {
  return (
    <div
      {...restProps}
      className={classNames(className, {
        [styles.opened]: isOpen,
      })}
      ref={ref}
    >
      <div className={contentWrapperClassName}>{children}</div>
    </div>
  )
}

export default AccordionAnimatedContent
